import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon } from '@livable/saas-react-components';
import { Button, Drawer, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useStyles from './styles';
export default function HeaderNotifications() {
  const classes = useStyles();
  const navigate = useNavigate();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    drawerIsOpen = _useState2[0],
    setDrawerIsOpen = _useState2[1];
  const redirect = path => {
    navigate(path);
    setDrawerIsOpen(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "notification",
    variant: "notification",
    onClick: () => setDrawerIsOpen(!drawerIsOpen),
    className: drawerIsOpen ? classes.isOpen : ''
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "notification"
  })), /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: drawerIsOpen,
    onClose: () => setDrawerIsOpen(false),
    className: classes.drawer,
    type: "underHeader"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.notifications
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.notificationContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.time
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.info
  }, "12:23 pm"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.info
  }, "08/02/19")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.info
  }, "775 Demo St."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.notificationText
  }, "Trash bill exceed 13% for May, 2020"))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "show-eye-on"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Review bills"))), /*#__PURE__*/React.createElement("div", {
    className: classes.notificationContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.time
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.info
  }, "12:01 pm"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.info
  }, "07/11/19")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.info
  }, "775 Demo St."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.notificationText
  }, "15 days overdue residents."))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "message"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Send balance reminder"))), /*#__PURE__*/React.createElement("div", {
    className: classes.notificationContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.time
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.info
  }, "11:49 pm"), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "light",
    className: classes.info
  }, "06/21/19")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    className: classes.info
  }, "7529 E. Pecan St."), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.notificationText
  }, "Utility credentials does not work"))), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "lock-unlocked"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Update credentials")))), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Clear all")), /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => redirect('notifications')
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "View all notifications"), /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  })))));
}